module.exports = new __parcel__URL__("status-simple--dark.8744d743.svg").toString();